import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=a556a594"
var script = {}
import style0 from "./appFooter.vue?vue&type=style&index=0&id=a556a594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports